<template>
  <div>
    <app-table
      ref="app-table"
      :is-current-page="false"
      :page-size="2000"
      :table-props="{ 'max-height': '450px' }"
      :table-key="table_key"
      :table-list-data="table_data"
    />
    <el-dialog
      title="新增品牌形象"
      :visible.sync="add_brand_config.is_show"
      :close-on-click-modal="false"
      :append-to-body="true"
      :modal-append-to-body="true"
      width="500px"
    >
      <create-brand v-if="add_brand_config.is_show" @confirm="onAddBrandConfirm" @cancel="onAddBrandCancel" />
    </el-dialog>
  </div>
</template>

<script>
import { getBrandListApi, addBrandApi } from '@/api/tool/brand';
import { getWechatChannelAccountListApi } from '@/api/tool/wechat-channel-account';
import { CHANNEL_INTERFACE_TYPE } from '@/enums';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'create-brand': () => import('../create-brand/index.vue'),
  },
  props: {
    // 表单项配置
    formItem: {
      type: Object,
      required: true,
    },
    // 初始化数据
    initOps: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      /** 表头配置 */
      table_key: require('./model/table-key.js')(this),
      /** 表格数据 */
      table_data: [],
      /** 新增品牌形象配置 */
      add_brand_config: {
        is_show: false,
        advertiser_id: null,
      },
    };
  },
  computed: {
    advertiser_ids() {
      const { advertiser_ids } = this.initOps;
      return advertiser_ids;
    },
    channel_interface() {
      const { channel_interface } = this.initOps;
      return channel_interface;
    },
  },
  created() {
    if (Object.keys(this.formItem.value.result_map).length) {
      this.edit();
    } else {
      this.generateTableData();
    }
  },
  methods: {
    /**
     * 生成表格数据
     * @returns {void}
     */
    generateTableData() {
      const data = this.advertiser_ids.map(advertiser_id => {
        return {
          advertiser_id,
          type: {
            options: this.formItem.value.type_selection,
            value: '',
          },
          target: {
            brand: {
              options: [],
              value: '',
            },
            wechat_channels: {
              options: [],
              value: '',
            },
          },
        };
      });
      this.table_data.push(...data);
    },
    /**
     * 编辑
     * @returns {void}
     */
    edit() {
      const data = Object.entries(this.formItem.value.result_map).map(([key, value]) => {
        return {
          advertiser_id: key,
          type: {
            options: this.formItem.value.type_selection,
            value: value.type,
          },
          target: {
            brand: {
              options: [],
              value: '',
            },
            wechat_channels: {
              options: [],
              value: '',
            },
            [value.type]: {
              options: value.options,
              value: value.value,
            },
          },
        };
      });
      this.table_data.push(...data);
    },
    /**
     * 获取目标配置
     * @param {string} type 目标类型
     * @param {Object} row 表格行数据
     * @returns {void}
     */
    getTargetConfig(type, row) {
      if (type === 'brand') {
        this.getBrandList(row.advertiser_id).then(res => {
          Object.assign(row.target[type], {
            options: res,
            value: '',
          });
        });
      } else {
        this.getWechatChannelAccountList(row.advertiser_id).then(res => {
          Object.assign(row.target[type], {
            options: res,
            value: '',
          });
        });
      }
    },
    /**
     * 新增品牌形象
     * @param {number} advertiser_id 广告主ID
     * @returns {void}
     */
    addBrand(advertiser_id) {
      Object.assign(this.add_brand_config, {
        is_show: true,
        advertiser_id,
      });
    },
    /**
     * 新增品牌形象弹窗确认
     * @param {Object} params 表单参数
     */
    onAddBrandConfirm(params) {
      const { name, brand_image_file } = params;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.GDT]: {
          [`${CHANNEL_INTERFACE_TYPE.GDT}_params[brand_image_file]`]: brand_image_file.file,
        },
      };
      const payload = {
        channel_interface: this.channel_interface,
        advertiser_id: this.add_brand_config.advertiser_id,
        name,
        ...strategy[this.channel_interface],
      };
      const form_data = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        form_data.append(key, value);
      });
      addBrandApi(form_data).then(({ id, name, image_url }) => {
        const row = this.table_data.find(({ advertiser_id }) => this.add_brand_config.advertiser_id === advertiser_id);
        row.target.brand.options.unshift({ label: name, value: `${id}#${name}`, image_url });
        this.$message.success('上传成功');
        this.onAddBrandCancel();
      });
    },
    /**
     * 新增品牌形象弹窗取消
     * @returns {void}
     */
    onAddBrandCancel() {
      this.add_brand_config.is_show = false;
    },
    /**
     * 获取品牌形象列表
     * @param {number} advertiser_id 广告主ID
     * @returns {Promise<Object[]>}
     */
    getBrandList(advertiser_id) {
      return new Promise((resolve, reject) => {
        const params = {
          advertiser_id,
          channel_interface: 'gdt',
        };
        getBrandListApi(params).then(res => {
          const result = (res?.list || []).map(({ id, name, image_url }) => ({ label: name, value: `${id}#${name}`, image_url }));
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 获取微信视频号列表
     * @param {number} advertiser_id 广告主ID
     * @returns {Promise<Object[]>}
     */
    getWechatChannelAccountList(advertiser_id) {
      return new Promise((resolve, reject) => {
        const params = {
          advertiser_id,
          channel_interface: 'gdt',
        };
        getWechatChannelAccountListApi(params).then(res => {
          const result = (res?.list || []).map(({ id, name }) => ({ label: name, value: id }));
          resolve(result);
        }).catch(reject);
      });
    },
  },
};
</script>
